import { useMutation } from "@tanstack/react-query";
import api from "apis";
import { ManageTagsRequest } from "apis/data-contracts";

const useTagsMutation = (documentCategoryUuid: string) => {
  return useMutation({
    mutationFn: (data: ManageTagsRequest) =>
      api.tag.manageTags(documentCategoryUuid, data),
  });
};

export default useTagsMutation;
